"use strict";

import _classCallCheck from "/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Coder } from "./abstract-coder"; // Clones the functionality of an existing Coder, but without a localName

export var AnonymousCoder = /*#__PURE__*/function (_Coder) {
  _inherits(AnonymousCoder, _Coder);

  var _super = _createSuper(AnonymousCoder);

  function AnonymousCoder(coder) {
    var _this;

    _classCallCheck(this, AnonymousCoder);

    _this = _super.call(this, coder.name, coder.type, undefined, coder.dynamic);
    _this.coder = coder;
    return _this;
  }

  _createClass(AnonymousCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      return this.coder.encode(writer, value);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return this.coder.decode(reader);
    }
  }]);

  return AnonymousCoder;
}(Coder);